import React, { Component } from "react";
import Button from "components/UI/Button";
import Box from "components/UI/Box";
import axios from "axios";
import Pagination from "components/Pagination";
import SlideSwitch from "components/SlideSwitch";
import Spinner from 'components/LoadingSpinner'
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { API_URL, ERROR_HANDLE } from "config/constants";
import theme from "../../../../Theme/theme";
import { submit } from '../../../../common/Utils'
import { Constants } from "../../../../common/constants";

const EDIT_TEXT = "Edit"
const DELETE_TEXT = "Delete"
const DELETE_ALERT_TEXT = "Are you sure you want to delete this promotion offer";
const HEADER_TEXT = ["Offer Name", "Product Name", "Description", "Active", "Actions"];
const CREATE_PROMOTION_TEXT = "Create Promotion"

class PromotionalOffer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            promotionOffers: [],
            currentPage: 0,
            rowCount: Constants.DEFAULT_PAGINATION_COUNT,
            isLoading: true
        };
        this.toggledPromotionId = null;
    }

    componentDidMount() {
        this.getPromotionalOffer();
    }

    headerItems = HEADER_TEXT.map((label, i) => {
        return (
            <p style={style.titleItem} key={i}>
                {label}
            </p>
        );
    });

    header = () => <div style={style.titleWrapper}>{this.headerItems}</div>;

    getPromotionalOffer() {
        const access_token = localStorage.getItem("access_token");
        const toastId = toast("Fetching Promotional Offers...");
        axios
            .get(`${API_URL}/promotional_offers`, {
                headers: {
                    "x-access-token": access_token
                }
            })
            .then(res => {
                toast.dismiss(toastId);
                this.setState({
                    ...this.state,
                    promotionOffers: res.data,
                    isLoading: false
                });
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    updatePromotionActiveState(activeState) {
        const toastId = toast("Updating Promotional offer...");
        const access_token = localStorage.getItem("access_token");
        axios
            .put(
                `${API_URL}/promotional_offers/${this.toggledPromotionId}`,
                {
                    active: activeState
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": access_token
                    }
                }
            )
            .then(res => {
                toast.dismiss(toastId);
                toast("Status Changed Successfully", { autoClose: 1500 });
                this.toggledPromotionId = null;
            })
            .catch(err => {
                this.updateToggleState(this.toggledPromotionId);
                this.toggledPromotionId = null;
                toast.dismiss(toastId);
                setTimeout(() => {
                    ERROR_HANDLE(err);
                }, 500);
            });
    }

    deletePromotionalOffer(promotion_id) {
        const access_token = localStorage.getItem("access_token");
        const toastId = toast("Deleting Promotional Offers...");
        axios
            .delete(`${API_URL}/promotional_offers/${promotion_id}`, {
                headers: {
                    "x-access-token": access_token
                }
            })
            .then(res => {
                toast.dismiss(toastId);
                this.removePromotion(promotion_id)
            })
            .catch(err => {
                ERROR_HANDLE(err);
            });
    }

    removePromotion(promotionId) {
        const index = this.state.promotionOffers.findIndex(promotion => promotion.promotion_id === promotionId);
        const promotion = [...this.state.promotionOffers]; // make a separate copy of the array
        if (index !== -1) {
            promotion.splice(index, 1);
            this.setState({
                promotionOffers: promotion
            });
        }
    }

    handleSlideSwitch = (activeState) => {
        if (this.toggledPromotionId) {
            this.updateToggleState(this.toggledPromotionId);
            this.updatePromotionActiveState(activeState)
        }
    };

    updateToggleState(toggledPromotionId) {
        this.setState(prevState => ({
            promotionOffers: prevState.promotionOffers.map(
                promotion => promotion.promotion_id === toggledPromotionId ? { ...promotion, active: !promotion.active } : promotion
            )
        }))
    }

    renderPromotionalDetail(currentItem) {
        return (
            <div style={style.valueWrapper}>
                <p style={style.valueItem}>{currentItem.offer_name}</p>
                <p style={style.valueItem}>{currentItem.product_name}</p>
                <p style={style.valueItem}>{currentItem.description}</p>
                <SlideSwitch
                    style={style.sliderStyle}
                    checked={currentItem.active}
                    onClick={() => {
                        this.toggledPromotionId = currentItem.promotion_id
                        this.handleSlideSwitch(!currentItem.active)
                    }}
                />
                <div style={{ display: "flex", flex: "1", justifyContent: "center", alignItems: "center" }}>
                    <Link to={{ pathname: "/gyms/PromotionalOffers/create/", state: { promotionId: currentItem.promotion_id } }}>
                        <Button
                            type="holo"
                            holo
                            style={{ ...style.editButton }}
                        >
                            {EDIT_TEXT}
                        </Button>
                    </Link>
                    <Button
                        type="holo"
                        holo
                        style={{ ...style.deleteButton }}
                        onClick={() => {
                            submit(DELETE_ALERT_TEXT, () => {
                                this.deletePromotionalOffer(currentItem.promotion_id);
                            })
                        }}
                    >
                        {DELETE_TEXT}
                    </Button>
                </div>
            </div >
        );
    }

    render() {
        const acl = localStorage.getItem("restricted_access");
        const rowCount = parseInt(this.state.rowCount)
        return (
            this.state.isLoading ? <Spinner loading={this.state.isLoading} /> : <div style={style.wrapper}>
                {acl === "false" ? <Link to="/gyms/PromotionalOffers/create/">
                    <Button
                        style={style.createPromotionButton}
                        type="primary"
                    >
                        {CREATE_PROMOTION_TEXT}
                    </Button></Link> : null}
                {this.state.promotionOffers.length > 0 &&
                    <Box style={style.box} outline>
                        {this.header()}
                        {this.state.promotionOffers.map((currentItem, index) =>
                            index >= this.state.currentPage * rowCount &&
                            index < this.state.currentPage * rowCount + rowCount && this.renderPromotionalDetail(currentItem)
                        )}
                    </Box>
                }
                {this.state.promotionOffers.length > 0 &&
                    <Pagination
                        currentPage={this.state.currentPage}
                        pageCount={this.state.promotionOffers.length / rowCount}
                        rowCount={rowCount}
                        pageAction={pageNumber => {
                            this.setState({ ...this.state, currentPage: pageNumber });
                        }}
                        updateRowCount={(rowCount) => this.setState({ rowCount, currentPage: 0 })}
                    />
                }
            </div >
        );
    }
}
export default PromotionalOffer;

const style = {
    titleWrapper: {
        display: "flex"
    },
    titleItem: {
        flex: "1",
        fontSize: "20px",
        color: theme.color.primaryBlue
    },
    box: {
        width: "900px"
    },
    wrapper: {
        display: "flex",
        justifyContent: "center",
        marginTop: "10px",
        flexDirection: "column",
        alignItems: "center"
    },
    valueWrapper: {
        display: "flex",
        borderTop: "1px solid " + theme.color.primaryBlue,
        borderRadius: "0.5px"
    },
    valueItem: {
        flex: "1",
        fontSize: "18px"
    },
    createPromotionButton: {
        width: "300px",
        fontSize: "20px",
        marginTop: "20px",
        marginBottom: "30px"
    },
    sliderStyle: {
        alignSelf: "center",
        marginTop: 5,
        width: 180
    },
    editButton: {
        width: "77px",
        height: "29px",
        fontSize: "16px",
        color: "#414141",
        marginRight: "5px",
        border: "solid 2px " + theme.color.primaryBlue
    },
    deleteButton: {
        width: "77px",
        height: "29px",
        fontSize: "16px",
        color: "#414141",
        marginLeft: "5px",
        border: "solid 2px " + theme.color.red
    }
};
